import axios, { AxiosResponse } from 'axios';

import { IF45 } from './FSluzbaPut';

export interface IMePozadavkyParams {
    order: string;
    mepozadavky: boolean;
    id?: number;
    offset?: number;
    limit?: number;
    isin?: string;
    sluzba?: string;
    datumvypisu?: string | Date;
    podal?: string;
    stav?: string;
}

export interface IMePozadavkyTable {
    offset: number;
    limit: number;
    count: number;
    order: string;
    zadosti: IMePozadavkyZadost[];
}

export interface IMePozadavkyZadost {
    id: number;
    sluzba: string;
    podal: string;
    datumpodani: string;
    datummvypisu: string;
    isinemise: string;
    stav: string;
    vystupzip: boolean;
    precteno: boolean;
}

export interface IMePozadavkyDetail {
    id: number;
    sluzba: string;
    podal: string;
    datumpodani: string;
    datumvypisu: string;
    isinemise: string;
    stav: string;
    vystupzip: true;
    datumvypisu2: string;
    idmajitel: string;
    idosobacdcp: string;
    kategorie: string;
    druhvypisu: string;
    cislouctu: string;
    kategoriemajitle: string;
    cislojednacispisovaznacka: string;
    prijmeno: string;
    jmeno: string;
    identifikacesoudu: string;
    cisloppn: string;
    cislozastavy: string;
    idzastavveritele: string;
    idzastavdluznika: string;
    idsubjppn: string;
    idspravceuctu: string;
    id1zastavy: string;
    id2zastavy: string;
    rolesubjektu: string;
    predcisli: string;
    idspravce: string;
    f45?: IF45;
    pristupy: {
        datum: string;
        typ: string;
        osoba: string;
    }[];
    odpovedi: {
        oid: number;
        jmeno: string;
        prijmeni: string;
    }[];
}

export const mePozadavkyTableDataApi = (data: IMePozadavkyParams) => {
    return axios({
        method: 'GET',
        url: 'Vypis',
        params: data
    }).then((resp: AxiosResponse<IMePozadavkyTable>) => resp.data);
};
export const mePozadavkyDetailApi = (id: number) => {
    return axios({
        method: 'GET',
        url: `Vypis/${id}`
    }).then((resp: AxiosResponse<IMePozadavkyDetail>) => resp.data);
};
export const mePozadavkyZruseniApi = (id: number) => {
    return axios({
        method: 'POST',
        url: `Vypis/${id}/Zruseni`
    }).then((resp: AxiosResponse<IMePozadavkyDetail>) => resp.data);
};
export const mePozadavkyDownloadApi = (
    id: number,
    typ: 'zip' | 'pdf' | 'xml' | 'html',
    oid?: string,
    language?: string
) => {
    return axios({
        method: 'GET',
        url: `Vypis/${id}/${typ.toUpperCase()}`,
        params: {
            oid: oid,
            jazyk: language
        }
    }).then((resp: AxiosResponse<{ redirect: string }>) => resp);
};
